module.exports = __webpack_public_path__ + "img/cepingwanc.c70a127c.png";